import * as React from 'react';

import { IAlertListModel, IAlertListWithCountModel } from '../../../interfaces/INote';

import { AlertListRow } from './AlertListRow';
import { AlertListTypeEnum } from '../../../utilities/Constants';
import { SortableHeader } from '../../../components/shared/SortableHeader';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IAlertListTableProps {
    alertListType: AlertListTypeEnum;
    allowEasyUpdate?: boolean;
    data: IAlertListWithCountModel | undefined;
    onEasyUpdateClick: (alertListItem: IAlertListModel) => void;
    onEditClick: (alertListItem: IAlertListModel) => void;
    onItemNameClick: (alertListItem: IAlertListModel) => void;
    onMarkCaseTriggerAsReadClick: (id: string, openCaseTriggerDetailPopup?: boolean) => void;
    onSortData: (
        key: string,
        order: string,
        subKey?: string | undefined,
        subGrandKey?: string | undefined
    ) => void;
    onViewNoteClick: (item: IAlertListModel) => void;
    previouslyViewedCases: string[];
}

export function AlertListTable(props: IAlertListTableProps) {
    return (
        <table className="table">
            <thead>
                <tr style={{ verticalAlign: 'middle' }}>
                    <SortableHeader
                        headerText="Type"
                        sortKey="originType"
                        onSort={props.onSortData}
                    />
                    <SortableHeader
                        headerText="Name"
                        sortKey="originEntityName"
                        onSort={props.onSortData}
                    />
                    <SortableHeader
                        headerComponent={<div style={{ whiteSpace: 'nowrap' }}>SQ Score</div>}
                        sortKey="sqScore"
                        onSort={props.onSortData}
                    />
                    <SortableHeader
                        headerText="Category/Details"
                        sortKey="details"
                        onSort={props.onSortData}
                    />
                    <SortableHeader
                        headerText="Purpose"
                        sortKey="purpose"
                        onSort={props.onSortData}
                    />
                    <SortableHeader
                        headerText="Decision"
                        sortKey="decision"
                        onSort={props.onSortData}
                    />
                    <SortableHeader
                        headerText="Action Target"
                        sortKey="actionTargetName"
                        onSort={props.onSortData}
                        noWrap
                    />
                    <SortableHeader
                        headerText="Writer"
                        sortKey="writer"
                        onSort={props.onSortData}
                    />
                    <SortableHeader
                        headerText="Date"
                        sortKey="modifiedDate"
                        onSort={props.onSortData}
                    />
                    <SortableHeader
                        headerText="Status"
                        sortKey="status"
                        onSort={props.onSortData}
                    />
                    <th />
                </tr>
            </thead>
            <tbody>
                {!!props.data?.count && !!props.data?.maxLimit && props.data?.count <= props.data?.maxLimit &&
                    props.data?.data.map((row) => (
                    <AlertListRow
                        alertListType={props.alertListType}
                        allowEasyUpdate={!!props.allowEasyUpdate}
                        alreadyViewed={props.previouslyViewedCases.includes(row.originEntityKey)}
                        item={row}
                        key={row.guid + row.alertTypeId}
                        onAlertItemNameClick={props.onItemNameClick}
                        onEasyUpdateClick={props.onEasyUpdateClick}
                        onEditClick={props.onEditClick}
                        onMarkCaseTriggerAsReadClick={props.onMarkCaseTriggerAsReadClick}
                        onViewNoteClick={props.onViewNoteClick}
                    />
                ))}
            </tbody>
        </table>
    );
}
